import React, {Component} from "react";
import Group from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import {ModalAction} from "../../../Components/Modal";
import Resource from "../../../Resource";
import {Tool} from "../../../App";
import Patient from "../../../Server/Patient";
import {connect} from "react-redux";
import Notif from "../../../Components/Notif";
import ModalPatient from "../../Modal/ModalPatient";
import Perms from '../../../Perms';

class PagePatients extends Component {
    constructor(props) {
        super(props);

        if (!Perms().PATIENTS.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    headerName: 'اطلاعات بیمار',
                    headerTooltip: 'اطلاعات بیمار',
                    children: [{
                        field: 'fileCode',
                        headerName: 'شماره پروند',
                        headerTooltip: 'شماره پرونده',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        filter: 'agTextColumnFilter'
                    }, {
                        field: 'nationalCode',
                        headerName: 'کد ملی',
                        headerTooltip: 'کد ملی',
                        filter: 'agTextColumnFilter',
                        cellRenderer: row => row.data.nationalCode || '-'
                    }, {
                        field: 'firstName',
                        headerName: 'نام',
                        headerTooltip: 'نام'
                    }, {
                        field: 'lastName',
                        headerName: 'نام خانوادگی',
                        headerTooltip: 'نام خانوادگی'
                    }, {
                        field: 'bloodGroupStr',
                        headerName: 'گروه خونی',
                        headerTooltip: 'گروه خونی',
                        cellClass: 'green',
                        cellRenderer: row => row.data.bloodGroupStr || '-'
                    }, {
                        field: 'genderStr',
                        headerName: 'جنسیت',
                        headerTooltip: 'جنسیت'
                    }, {
                        field: 'birthDate',
                        headerName: 'تاریخ تولد',
                        headerTooltip: 'تاریخ تولد'
                    }, {
                        field: 'provinceStr',
                        headerName: 'استان',
                        headerTooltip: 'استان'
                    }, {
                        field: 'cityStr',
                        headerName: 'شهر',
                        headerTooltip: 'شهر'
                    }]
                }, {
                    headerName: 'اطلاعات ثبت کننده',
                    headerTooltip: 'اطلاعات ثبت کننده',
                    children: [{
                        field: 'creatorFullname',
                        headerName: 'نام ثبت کننده',
                        headerTooltip: 'نام ثبت کننده'
                    }, {
                        field: 'createDateTime',
                        headerName: 'زمان ثبت',
                        headerTooltip: 'زمان ثبت',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime
                    }]
                }, {
                    field: 'statusStr',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: 'left',
                    sortable: false,
                    enableRowGroup: false,
                    valueGetter: row => row.data.statusStr,
                    cellRenderer: 'state'
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: 'left',
                    sortable: false,
                    filter: false,
                    minWidth: 120,
                    hide: !(Perms().PATIENTS.UPDATE || Perms().PATIENTS.ACTIVATE_DEACTIVATE),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {row.data.statusId === 56 && <GridState theme={'green'}>{row.data.statusStr}</GridState>}
                            {row.data.statusId === 57 && <GridState theme={'red'}>{row.data.statusStr}</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {Perms().PATIENTS.UPDATE && <GridButton type={"button"} theme={'edit'} title={'ویرایش'} onClick={this.update.bind(this, row.data)}/>}
                            {row.data.statusId === 56 && Perms().PATIENTS.ACTIVATE_DEACTIVATE && <GridButton type={"button"} theme={'red'} icon={Resource.IMAGE.PACK.PADLOCK.WHITE} title={'غیرفعال'} onClick={this.deactivate.bind(this, row.data)}/>}
                            {row.data.statusId === 57 && Perms().PATIENTS.ACTIVATE_DEACTIVATE && <GridButton type={"button"} theme={'green'} icon={Resource.IMAGE.PACK.OPEN_LOCK.WHITE} title={'فعال'} onClick={this.activate.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'ویرایش',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EDIT1.BLACK}" alt="">`,
                            action: this.update.bind(this, params.node.data),
                            disabled: !Perms().PATIENTS.UPDATE
                        }, {
                            name: 'فعال سازی',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.OPEN_LOCK.BLACK}"/>`,
                            action: this.activate.bind(this, params.node.data),
                            disabled: params.node.data.statusId === 56 || !Perms().PATIENTS.ACTIVATE_DEACTIVATE
                        }, {
                            name: 'غیرفعال سازی',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.PADLOCK.BLACK}"/>`,
                            action: this.deactivate.bind(this, params.node.data),
                            disabled: params.node.data.statusId === 57 || !Perms().PATIENTS.ACTIVATE_DEACTIVATE
                        },
                            'separator',
                            ...params.defaultItems];
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre'}>نشان دهنده گروه خونی بیمار می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'green'}>فعال</GridState> بیمار فعال می باشد.</p>
                                <p><GridState theme={"red"}>غیر فعال</GridState> بیمار غیر فعال است و امکان استفاده در سامانه وجود ندارد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'edit'} title={'ویرایش'}/> درصورت نیاز به ویرایش پرونده بیمار می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'green'} title={'فعال'} icon={Resource.IMAGE.PACK.OPEN_LOCK.WHITE}/> درصورت نیاز به فعال سازی پرونده بیمار از این قسمت اقدام کنید.</p>
                                <p><GridButton theme={'red'} title={'غیرفعال'} icon={Resource.IMAGE.PACK.PADLOCK.WHITE}/> در صورت نیاز به غیر فعال سازی پرونده بیمار از این قسمت اقدام کنید.</p>
                            </div>
                        </div>
                    </div>;
                },
                onRowDoubleClicked: row => {
                    this.ref.modalPatient.current.open(row.data, ModalAction.VIEW);
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            modalPatient: React.createRef()
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <Group className={'PagePatients-group mar-10'} title={'لیست بیماران'} description={'لیست بیماران داخل سامانه از این قسمت قابل مشاهده و اصلاح می باشد.'}>
                <Grid refer={this.ref.grid} id={'patients'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <ModalPatient refer={this.ref.modalPatient} onSuccess={this.updateGrid.bind(this)}/>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        Patient.list()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    activate(row, props = {loading: _ => null}) {
        props.loading();

        Patient.updatePatientState({
            fileCodeId: row.fileCodeId,
            statusId: 56
        }).then(_ => {
            new Notif('بیمار با موفقیت فعال شد.').show();

            this.updateGrid();

            props.loading(false);
        }).catch(message => {
            new Notif(message).show();

            props.loading(false);
        });
    }

    addClickHandler() {
        this.ref.modalPatient.current.open(null, ModalAction.INSERT);
    }

    deactivate(row, props = {loading: _ => null}) {
        props.loading();

        Patient.updatePatientState({
            fileCodeId: row.fileCodeId,
            statusId: 57
        }).then(_ => {
            new Notif('بیمار با موفقیت غیرفعال شد.').show();

            this.updateGrid();

            props.loading(false);
        }).catch(message => {
            new Notif(message).show();

            props.loading(false);
        });
    }

    update(row) {
        this.ref.modalPatient.current.open(row, ModalAction.UPDATE);
    };
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(PagePatients)